import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from '../../../styles/HomeLanding/HomeLanding.module.css'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, FreeMode, Mousewheel, Navigation, Pagination } from 'swiper';
import { Button } from 'reactstrap';
import { blogData, UAEBlogs, videoTestimonial, UAEVideoTestimonial } from '@/constants/common';
import Link from 'next/link';
import { getUAEBlogsData } from '@/services/signUpServices';

const BlogsAndVideos = () => {
    const [blogsList, setBlogsData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const data = {
        blogs: blogsList,
        caseStudies: [
            {
                img: '/assets/HomeLanding/Thumbnail-Heineken.webp',
                altTxt: 'Heineken',
                title: 'Know how 314 Heineken breweries in Nigeria gained automated business momentum!',
                desc: "QueueBuster was selected as the best solution to achieve Heineken's requirements. Within 314 Heineken-owned breweries in Nigeria, the system was implemented and changed how these breweries handled their billing and inventory management processes.",
                link: '/casestudy/heineken',
            },
            {
                img: '/assets/HomeLanding/Thumbnail-hul.webp',
                altTxt: 'HUL',
                title: "How QueueBuster Improved HUL's SKU Visibility by 100%",
                desc: 'QueueBuster POS was deployed over 4000+ sub-stockists to provide real-time SKU tracking right from distributors to sub-stockists to Kirana stores.',
                link: '/casestudy/hul',
            },
            {
                img: '/assets/HomeLanding/Thumbnail-IRCTC.webp',
                altTxt: 'IRCTC',
                title: 'How QueueBuster Transformed Train Catering Services for IRCTC',
                desc: 'QueueBuster collaborated with multiple tender awardees to integrate a full-fledged billing and inventory management solution for Pine Labs card-swiping machines.',
                link: '/casestudy/irctc',
            },
            {
                img: '/assets/HomeLanding/Thumbnail-Cococart.webp',
                altTxt: 'CocoCart',
                title: 'How QueueBuster POS Transformed One Store into 65',
                desc: 'QueueBuster turned out to be the perfect solution, as it is the only POS software in India that can serve both requirements.',
                link: '/casestudy/coco-cart',
            },
        ],
        // videos: UAEVideoTestimonial,
    };

    const [activeTab, setActiveTab] = useState('blogs');

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };


    const fetchBlogDataUAE = async () => {
        try {
            setIsLoading(true);
            const blogs = await getUAEBlogsData();
            setBlogsData(blogs || []);
        } catch (error) {
            console.error('Error fetching blog data UAE:', error);
            setBlogsData([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchBlogDataUAE();
    }, []);


    return (

        <div style={{ height: "50rem" }}>
            <div style={{
                //  background: 'linear-gradient(to bottom, #F2FAFF 80%, #FFFFFF 20%)', 
                backgroundColor: "#F2FAFF",
                position: 'relative',
                padding: '5rem',
                borderRadius: "3rem",
                height: "35rem"
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2.5rem' }}>
                    <div style={{ display: 'flex', gap: "1rem" }}>

                        <h2 style={{ fontWeight: "600", fontSize: "2.8rem", fontFamily: "GilroyBold" }}>Insights to <br /> <span style={{ color: "#2A6AB4" }}>Grow Your Business</span></h2>
                        {/* <div className={styles.vector}>
                        <div className={styles.vectorImg}> <Image src="/assets/HomeLanding/Vector.svg" alt="POS Solution" fill /></div>
                    </div> */}
                    </div>
                    <div style={{ display: 'flex', gap: '1rem', padding: "1rem", backgroundColor: "white", borderRadius: "5rem", height: "6.5rem" }}>
                        <Button
                            onClick={() => handleTabChange('blogs')}
                            style={{

                                border: activeTab === 'blogs' ? '2px solid #2a6ab4' : '1px solid #ccc',
                                backgroundColor: activeTab === 'blogs' ? '#2a6ab4' : '#fff',
                                color: activeTab === 'blogs' ? '#fff' : '#000',
                                cursor: 'pointer',
                                border: 'none',
                                padding: "0rem 3rem",
                                fontSize: "1.4rem",
                                borderRadius: "2.5rem",
                                fontFamily: "GilroyMedium"
                            }}
                        >
                            News
                        </Button>
                        <Button
                            onClick={() => handleTabChange('caseStudies')}
                            style={{

                                border: activeTab === 'caseStudies' ? '2px solid #2a6ab4' : '1px solid #ccc',
                                backgroundColor: activeTab === 'caseStudies' ? '#2a6ab4' : '#fff',
                                color: activeTab === 'caseStudies' ? '#fff' : '#000',
                                cursor: 'pointer',
                                border: "none",
                                padding: "1rem 3rem",
                                fontSize: "1.4rem",
                                borderRadius: "4rem",
                                fontFamily: "GilroyMedium"
                            }}
                        >
                            Case Studies
                        </Button>
                        {/* <Button
                        onClick={() => handleTabChange('videos')}
                        style={{
                            border: activeTab === 'videos' ? '2px solid #2a6ab4' : '1px solid #ccc',
                            backgroundColor: activeTab === 'videos' ? '#2A6AB4' : '#fff',
                            color: activeTab === 'videos' ? '#fff' : '#000',
                            cursor: 'pointer',
                             border:"none",
                             padding:"1rem 3rem",
                             fontSize:"1.5rem",
                             borderRadius:"4rem",
                             fontFamily:"GilroyMedium"
                        }}
                    >
                        Videos
                    </Button> */}
                    </div>
                </div>
                <div style={{ height: "20rem" }}>
                    {isLoading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <p>Loading...</p>
                        </div>
                    ) : data[activeTab] && data[activeTab].length > 0 ? (
                        <Swiper
                            className="custom-features-swiper blogSwiper"
                            spaceBetween={30}
                            slidesPerView={'auto'}
                            loop={data[activeTab].length > 1}
                            autoplay={data[activeTab].length > 1 ? {
                                delay: 10000,
                                disableOnInteraction: false,
                            } : false}
                            navigation={{
                                prevEl: '.custom-prev-device',
                                nextEl: '.custom-next-device',
                            }}
                            speed={1000}
                            pagination={{ clickable: true }}
                            modules={[Autoplay, Pagination, Mousewheel, FreeMode]}
                            freeMode={true}
                            mousewheel={{
                                forceToAxis: true,
                                invert: false,
                                sensitivity: 1,
                            }}
                            grabCursor={true}
                            watchSlidesProgress={true}
                            watchSlidesVisibility={true}
                            onBeforeInit={(swiper) => {
                                if (swiper.slides && swiper.slides.length === 0) {
                                    swiper.allowSlideNext = false;
                                    swiper.allowSlidePrev = false;
                                }
                            }}
                        >
                            {data[activeTab].map((item, index) => (

                                <SwiperSlide key={index} style={{ width: "25.4rem" }}>
                                    <Link style={{ color: "black" }} href={item.link} passHref target="_blank">
                                        <div
                                            style={{
                                                borderRadius: '1.5rem',
                                                padding: '1rem',
                                                height: "35rem",
                                                backgroundColor: '#fff',
                                                border: 'none',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {activeTab === 'videos' ? (
                                                <div>
                                                    <iframe loading="lazy" width="100%" src={item?.link} frameborder="0" allowfullscreen style={{ borderRadius: '1.5rem', height: '15rem' }}></iframe>
                                                    <h3 style={{ fontSize: '1.6rem', margin: '1rem 0' }}>{item.company}</h3>
                                                    <p style={{ fontSize: '1.2rem', color: '#475467', lineHeight: '1.5' }}>{item.text}</p></div>
                                            ) : (
                                                <div style={{ position: "relative", width: "100%", height: "17rem" }}>
                                                    <Image
                                                        src={item.img}
                                                        alt={item.altTxt}

                                                        style={{
                                                            objectFit: 'cover',
                                                            borderRadius: '1.5rem',
                                                            marginBottom: '1rem',
                                                            width: '100%',
                                                            height: "100%"
                                                        }}
                                                        fill />
                                                </div>
                                            )}
                                            <p style={{ fontSize: '1rem', margin: '1rem 0', fontFamily: "GilroyMedium", color: "black" }}>{item.date}</p>
                                            <h3 style={{ fontSize: '1.6rem', marginBottom: '1rem', fontFamily: "GilroyMedium", display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.5', color: "black" }}>{item.title}</h3>
                                            <p style={{ fontSize: '1.2rem', color: '#475467', lineHeight: '1.5', fontFamily: "GilroyMedium", display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.5', }}>{item.desc}</p>
                                            {/* <p >{item.desc}</p> */}

                                        </div>

                                    </Link>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    ) : (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <p>No {activeTab} available</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BlogsAndVideos;